/**
 * Idézet service module
 * @author Erik Banhalmi 2017.06.28.
 */
import angular from 'angular';

import { QoutationService } from './qoutation-service.service';

const MODULE_NAME = 'QoutationService';

export default angular.module(MODULE_NAME, []).service('QoutationService', QoutationService).name;

